import React from 'react';
import { useRoutes } from 'react-router-dom';
import Login from '../views/login'
import Home from '../views/home'
// 预审
import PreliminaryHearing from '../views/homeCopy'
// 测试
import Test from '../views/homeCopy copy'

//机构
import Organization from '../views/organization/index'
import HomeCentre from '../views/organization/homeCentre';
import ApplyAdd from '../views/organization/apply/applyAdd';
import ApplyList from '../views/organization/apply/applyList';
import PersonnelAdd from '../views/organization/personnel/personnelAdd';
import PersonnelList from '../views/organization/personnel/personnelList';

// 省厅
import HomeProvince from '../views/province/homeProvince/index'
import Oeuvre from '../views/province/worksAdmin/oeuvre'
import AuditList from '../views/province/worksAdmin/auditList'
import RecommendationList from '../views/province/worksAdmin/recommendationList'

//协议
import Copyright from '../views/agreement/copyright.jsx'
import PrivacyPolicy from '../views/agreement/privacyPolicy.jsx'

import NotFound from '../views/notFound/index'
import { useSelector } from 'react-redux'

// const num = useSelector((state) => {
//   return state
// })
// token: num.storeLogin.token.payload

const IndexRouter = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/preliminaryHearing",
    element: <PreliminaryHearing />
  },
  {
    path: "/test",
    element: <Test />
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/copyright",
    element: <Copyright />
  },
  {
    path: "/privacyPolicy",
    element: <PrivacyPolicy />
  },
  {
    path: "/organization",
    element: <Organization />,
    children: [
      {
        path: "/organization/homeCentre",
        element: <HomeCentre />
      },
      {
        path: "/organization/applyAdd",
        element: <ApplyAdd />
      },
      {
        path: "/organization/applyList",
        element: <ApplyList />
      },
      {
        path: "/organization/personnelAdd",
        element: <PersonnelAdd />
      },
      {
        path: "/organization/personnelList",
        element: /* withLoadingComponent */(<PersonnelList />)
      },
      {
        path:'/organization/homeProvince',
        element:<HomeProvince/>
      },
      {
        path:'/organization/oeuvre',
        element:<Oeuvre/>
      },
      {
        path:'/organization/auditList',
        element:<AuditList/>
      },
      {
        path:'/organization/recommendationList',
        element:<RecommendationList/>
      },
    ]
  },
  {
    path: "*",
    element: <NotFound />
  },
]

const Router = () => {
  const routes = useRoutes(IndexRouter);
  return routes;
};

export default Router;
